import { ROUTE_SELECTED_BORDER_WIDTH } from "../../CircuitPathsLayer/constants";
import type { DestinationDotProps } from "./types";

const RING_WIDTH_PX = 2;
const DOT_FILL_COLOR = "#ffffff";

export const DestinationDot = ({
  x,
  y,
  ringColor,
  opacity = 1,
  hoverStyle,
}: DestinationDotProps) => {
  // A zero-length round-capped stroke: non-scaling-stroke keeps the dot the casing's width at every zoom.
  const dotPath = `M${x},${y} L${x},${y}`;

  return (
    <g style={hoverStyle} opacity={opacity} data-testid="destination-dot">
      <path
        d={dotPath}
        stroke={ringColor}
        strokeWidth={ROUTE_SELECTED_BORDER_WIDTH}
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d={dotPath}
        stroke={DOT_FILL_COLOR}
        strokeWidth={ROUTE_SELECTED_BORDER_WIDTH - 2 * RING_WIDTH_PX}
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
      />
    </g>
  );
};
